import {
  add,
  eachDayOfInterval,
  eachMonthOfInterval,
  eachWeekOfInterval,
  endOfISOWeek,
  endOfMonth,
  format,
  isSameMonth,
  startOfISOWeek,
  startOfMonth,
  subDays,
} from "date-fns";
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "dateStartPreview",
    "dateEndPreview",
    "startDate",
    "endDate",
    "singleDate",
    "filterCalendar",
  ];

  connect() {
    this.startingDate = this.startDateTarget;
    this.endingDate = this.endDateTarget;
    this.singleDate = this.singleDateTarget;
    this.filterCalendar = this.filterCalendarTarget;
    if (
      this.startingDate.value.length > 0 &&
      this.endingDate.value.length > 0
    ) {
      this.dateStartPreviewTarget.innerText = this.getFinalDate(
        this.startingDate.value
      );
      this.dateEndPreviewTarget.innerText = this.getFinalDate(
        this.endingDate.value
      );
    } else if (this.startingDate.value) {
      this.dateStartPreviewTarget.innerText = this.getFinalDate(
        this.startingDate.value
      );
    }

    this.currentYear = new Date().getFullYear();
    this.monthsAhead = eachMonthOfInterval({
      start: new Date(this.currentYear, 0, 1),
      end: add(new Date(this.currentYear, 0, 1), {
        months: 11,
      }),
    });

    this.months = this.monthsAhead.map((month) => ({
      long: format(month, "MMMM"),
      short: format(month, "MMM"),
    }));

    this.monthArray = this.monthsAhead.map((month) => {
      return {
        year: month.getFullYear(),
        weeksArray: this.getMountMatrix(
          {
            year: month.getFullYear(),
            mount: month.getMonth(),
          },
          (date, { isSameMonth: sameMonth }) => {
            return sameMonth && date > subDays(new Date(), 1)
              ? {
                  disabled: false,
                  number: format(date, "dd"),
                  date: format(date, "yyyy.MM.dd"),
                }
              : {
                  disabled: true,
                  number: format(date, "dd"),
                  date: format(date, "yyyy.MM.dd"),
                };
          }
        ),
      };
    });
  }

  show_calendar(el) {
    const customPopup = document.querySelector("#custom-popup");
    const isPopup = el.target.getAttribute("data-target");
    const isCustomCalendar = el.target.classList.contains("custom-calendar");

    if (customPopup && isCustomCalendar) {
      this.closeCurrentPopup(customPopup);
      return;
    } else if (customPopup && !isPopup) {
      this.closeCurrentPopup(customPopup);
      return;
    }

    if (
      isCustomCalendar ||
      el.target.getAttribute("type") === "month" ||
      el.target.getAttribute("type") === "day"
    ) {
      if (!isPopup) {
        const popupEl = document.createElement("div");
        const monthEl = document.createElement("p");
        const monthItems = document.createElement("ul");
        const dayEl = document.createElement("p");
        const daysTable = document.createElement("table");
        const dateStart = this.startDateTarget;
        const dateEnd = this.endDateTarget;
        monthItems.classList.add("custom-calendar-popup-list");
        popupEl.classList.add("custom-calendar-popup");
        popupEl.setAttribute("id", "custom-popup");
        popupEl.setAttribute("data-target", "popup");
        monthEl.textContent = "Months";
        popupEl.appendChild(monthEl);

        this.months.map((m, i) => {
          const monthItem = document.createElement("li");
          monthItem.textContent = m.short;
          monthItem.setAttribute("data-target", "popup");
          monthItem.setAttribute("data-index", i);
          monthItem.setAttribute("type", "month");
          if (
            !isNaN(new Date(dateStart.value).valueOf())
              ? i === new Date(dateStart.value).getMonth()
              : i === new Date().getMonth()
          ) {
            monthItem.classList.add("active");
          }
          monthItems.appendChild(monthItem);
        });
        popupEl.appendChild(monthItems);
        dayEl.textContent = "Days";
        popupEl.appendChild(dayEl);
        this.setTableRowDate(
          daysTable,
          this.monthArray[
            !isNaN(new Date(dateStart.value).valueOf())
              ? new Date(dateStart.value).getMonth()
              : new Date().getMonth()
          ].weeksArray,
          dateStart.value,
          dateEnd ? dateEnd.value : ""
        );
        popupEl.appendChild(daysTable);
        if (this.filterCalendar.value === "true") {
          document.getElementById("calendar-field").appendChild(popupEl);
          document.getElementById("custom-filter-date-field").style.display =
            "flex";
          document.getElementById("filter-field").style.display = "none";
          document.getElementById("select-options-filter").style.display =
            "none";
        } else {
          setTimeout(() => {
            const elementsWithSpecificDate = [];
            const allElementsWithDataDate =
              document.querySelectorAll("[data-date]");
            const replacedValue = dateStart.value.replaceAll("-", ".");

            allElementsWithDataDate.forEach((element) => {
              if (element.getAttribute("data-date") === replacedValue) {
                elementsWithSpecificDate.push(element);
              }
            });

            elementsWithSpecificDate[0].classList.add("active");
          }, 100);
          // dateStart.value
          el.target.insertBefore(popupEl, el.target.firstChild);
        }
      } else if (isPopup && el.target.hasAttribute("type")) {
        const monthIdx = el.target.getAttribute("data-index");
        const dateStart = this.startDateTarget;
        const dateEnd = this.endDateTarget;
        const type = el.target.getAttribute("type");
        const dateStartText = this.dateStartPreviewTarget;
        const dateEndText = this.dateEndPreviewTarget;

        if (type === "month") {
          this.clearUlValues(el.target.parentElement.childNodes);
          el.target.classList.add("active");
          this.updateTable(
            customPopup,
            monthIdx,
            dateStart.value,
            dateEnd ? dateEnd.value : ""
          );
        } else if (type === "day") {
          if (!dateEnd) {
            dateStartText.innerText = `${format(
              new Date(el.target.getAttribute("data-date").replace(/-/g, ".")),
              "MMMM dd, yyyy"
            )}`;
            dateStart.value = el.target.getAttribute("data-date");
            this.updateTable(
              customPopup,
              new Date(
                el.target.getAttribute("data-date").replace(/-/g, ".")
              ).getMonth(),
              dateStart.value,
              ""
            );
            this.updateDateInPreview(dateStart.value);
            this.closeCurrentPopup(customPopup);
          } else if (dateStart && !dateEnd) {
            
            dateEnd.innerText = `${format(
              new Date(el.target.getAttribute("data-date").replace(/-/g, ".")),
              "MMMM dd, yyyy"
            )}`;
            dateEnd.value = el.target.getAttribute("data-date");
            this.updateTable(
              customPopup,
              new Date(
                el.target.getAttribute("data-date").replace(/-/g, ".")
              ).getMonth(),
              dateStart.value,
              dateEnd.value
            );
          } else if (!dateStart.value) {
            dateStartText.innerText = `${format(
              new Date(el.target.getAttribute("data-date").replace(/-/g, ".")),
              "MMMM dd, yyyy"
            )}`;
            dateStart.value = el.target.getAttribute("data-date");

            this.updateTable(
              customPopup,
              new Date(
                el.target.getAttribute("data-date").replace(/-/g, ".")
              ).getMonth(),
              dateStart.value,
              dateEnd.value
            );
          } else if (dateStart.value && dateEnd.value) {
            dateStart.value = null;
            dateEnd.value = null;
            dateStartText.innerText = "--";
            dateEndText.innerText = "--";
            dateStart.innerText = `${format(
              new Date(el.target.getAttribute("data-date").replace(/-/g, ".")),
              "MMMM dd, yyyy"
            )}`;
            dateStartText.innerText = `${format(
              new Date(el.target.getAttribute("data-date").replace(/-/g, ".")),
              "MMMM dd, yyyy"
            )}`;

            dateStart.value = el.target.getAttribute("data-date");
            this.updateTable(
              customPopup,
              new Date(
                el.target.getAttribute("data-date").replace(/-/g, ".")
              ).getMonth(),
              dateStart.value,
              dateEnd.value
            );
          } else if (
            !dateEnd.getAttribute("data-day") &&
            new Date(el.target.getAttribute("data-date")).getTime() >
              new Date(dateStart.value).getTime()
          ) {
            if (dateEnd.getAttribute("single") === "false") {
              dateEndText.innerText = `${format(
                new Date(
                  el.target.getAttribute("data-date").replace(/-/g, ".")
                ),
                "MMMM dd, yyyy"
              )}`;
              dateEnd.value = el.target.getAttribute("data-date");
            } else {
              dateStartText.innerText = `${format(
                new Date(
                  el.target.getAttribute("data-date").replace(/-/g, ".")
                ),
                "MMMM dd, yyyy"
              )}`;
              dateStart.value = el.target.getAttribute("data-date");
            }

            this.updateTable(
              customPopup,
              new Date(
                el.target.getAttribute("data-date").replace(/-/g, ".")
              ).getMonth(),
              dateStart.value,
              dateEnd.value
            );

            setTimeout(()=> {
              this.closeCurrentPopup(customPopup);
            }, 250)
          } else {
            dateStartText.innerText = `${format(
              new Date(el.target.getAttribute("data-date").replace(/-/g, ".")),
              "MMMM dd, yyyy"
            )}`;
            dateStart.value = el.target.getAttribute("data-date");

            this.updateTable(
              customPopup,
              new Date(
                el.target.getAttribute("data-date").replace(/-/g, ".")
              ).getMonth(),
              dateStart.value,
              dateEnd.value
            );
          }
        }
      }
    }
  }

  updateDateInPreview(value) {
    const date = this.getFinalDate(value);
    document.getElementById("expirationDatePreview").innerText = date;
  }

  convertDateToDays(value) {
    const oneDay = 1000 * 3600 * 24;
    const expirationDate = new Date(value);
    const currentDate = new Date();
    const expirationDays = Math.round((expirationDate - currentDate) / oneDay);
    return expirationDays;
  }

  getFinalDate(value) {
    const date = new Date(value);
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    const finalDate = date.toLocaleDateString("en-US", options);
    return finalDate;
  }

  updateTable(element, monthIdx, start, end) {
    const daysTable = document.createElement("table");
    element.removeChild(element.querySelector("table"));
    this.setTableRowDate(
      daysTable,
      this.monthArray[monthIdx].weeksArray,
      start,
      end
    );
    element.appendChild(daysTable);
  }

  closeCurrentPopup(node) {
    node.parentNode.removeChild(node);
  }

  clearUlValues(nodes) {
    nodes.forEach((el) => {
      if (el.classList.contains("active")) {
        el.classList.remove("active");
      }
    });
  }

  getMountMatrix({ year, mount }, convertDate = (val) => val) {
    const date = new Date(year, mount);
    const matrix = eachWeekOfInterval(
      {
        start: startOfMonth(date),
        end: endOfMonth(date),
      },
      {
        weekStartsOn: 1,
      }
    );

    return matrix.map((weekDay) =>
      eachDayOfInterval({
        start: startOfISOWeek(weekDay),
        end: endOfISOWeek(weekDay),
      }).map((day) =>
        convertDate(day, {
          isSameMonth: isSameMonth(date, day),
        })
      )
    );
  }

  setTableRowDate(el, numbers, startDate, endDate) {
    var tbdy = document.createElement("tbody");
    numbers.map((row) => {
      var tr = document.createElement("tr");
      row.map((r) => {
        var td = document.createElement("td");

        if (this.filterCalendar.value !== "true") {
          if (r.disabled) {
            td.classList.add("disabled");
          }
        }

        if (startDate == r.date || endDate == r.date) {
          td.classList.add("active");
        } else if (startDate < r.date && r.date < endDate) {
          td.classList.add("range");
        }

        td.setAttribute("type", "day");
        td.setAttribute("data-target", "popup");
        td.setAttribute("data-date", r.date);
        td.appendChild(document.createTextNode(r.number));
        tr.appendChild(td);
      });
      tbdy.appendChild(tr);
    });

    el.appendChild(tbdy);
  }
}
